/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import ArrowSvg from '../../../../assets/images/arrow-back.svg'
import QrSvg from '../../../../assets/images/qrlogo.svg'
import Layout from '../../../components/Provider/Layout'
import QrScan from '../../../components/Provider/QrScan'
import CustomCard from '../../../components/shared/CustomCard'
import Loading from '../../../components/shared/Loading'
import { default as MessageModal, default as SimpleModal } from '../../../components/shared/MessageModal'
import Search from '../../../components/shared/Search'
import useLocalStorage from '../../../hooks/useLocalStorage'
import ProvidersService from '../../../services/ProviderServices'
// import Div100vh from 'react-div-100vh'
import './Delivery.scss'

function Delivery({ match }) {
  const [textSearch, setTextSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [modalWarning, setModalWarning] = useState(false)
  const [modalNoqr, setModalNoqr] = useState(false)
  const [modalNoInternet, setModalNoInternet] = useState(false)
  const [modalIncomplete, setModalIncomplete] = useState(false)
  const [deliveryData, setDeliveryData] = useState([])
  const [scanning, setScanning] = useState(false)
  const history = useHistory()
  const { location: { state } } = history
  const [userappret] = useLocalStorage('userappret')

  const [alertSession, setAlertSession] = useState(false)
  const deliveryReducer = useSelector(state => state.deliveryReducer)

  useEffect(() => {
    const { clientPhoto, dniPhoto, sign, oc } = deliveryReducer
    console.log('Delivery -> Evidencias: ', deliveryReducer)
    if (clientPhoto && dniPhoto && sign) {
      // setAlertSession(true)
      // setTimeout(() => {
      //   return history.push(`/entrega/${oc}`, {
      //     searching: state ? state.searching : ''
      //     //agregar el campo : username
      //   })
      // }, 2500)
    }
    if (state && state.searching) {
      setTextSearch(state.searching)
      fetchData(state.searching, userappret.pickupPointId)
      history.replace()
    }
  }, [])

  const handleTextChange = (e) => {
    const value = e.target.value
    setTextSearch(value)
    setDeliveryData([])
  }

  const checkOc = async oc => {
    try {
      setLoading(true)
      console.log('getCudsByOc 1');

      //validar inicio de entrega
      console.log('Inicio de entrega');

      const cuds = await ProvidersService.getCudsByOc(oc)
      console.log('getCudsByOc 2');
      console.log("checkOc!")
      console.log("OC!", oc)
      console.log("cuds!", cuds)

      const incompleteCuds = cuds.filter(cud => (cud.searchStatus && cud.searchStatus.toUpperCase() === 'PENDIENTE') || (cud.status && cud.status.toUpperCase() === 'UNRECEIVED'))
      if (incompleteCuds.length > 0) {
        setLoading(false)
        return false
      }
      const receivedCuds = cuds.filter(cud => (cud.estado && cud.estado.toUpperCase() === 'RECEPCIONADO'))
      if (receivedCuds.length === 0) {
        setLoading(false)
        return false
      }
      return true
    } catch (e) {
      console.log('getCudsByOc 3');
      console.log(e)
      setLoading(false)
      setModalNoInternet(true);
      return -1
    }
  }

  const renderValues = () => {
    if (deliveryData.length === 0) {
      return (
        <div className='delivery-placeholder'>
          <p>Para comenzar a entregar pedidos, ingresa el DNI del cliente.</p>
        </div>
      )
    }
    return deliveryData.map(d => (
      <CustomCard
        key={d.oc}
        dni={d.dni}
        guide={d.guide}
        oc={d.oc}
        name={d.name}
        cuds={d.details}
        details={d.details}
        filterCuds
        onClick={async () => {
          const isValid = await checkOc(d.oc)
          if (isValid) {
            history.push(`/entrega/${d.oc}`, {
              searching: textSearch,
              username: d.name
            })
          }
          else {
            setModalIncomplete(true)
          }
        }}
      />
    ))
  }

  const handleEnter = () => {
    fetchData(textSearch, userappret.pickupPointId)
  }

  const fetchData = async (text, pickupPointId) => {
    try {
      if (text.trim() !== '') {
        setLoading(true)
        const ocs = await ProvidersService.getOcsByDni(text, pickupPointId)
        if (ocs.length > 0) {
          setDeliveryData(await formatData(ocs))
          setLoading(false)
        } else {
          setLoading(false)
          setModalWarning(true)
        }
      }
    } catch (e) {
      console.log(e)
      setLoading(false)
      setModalNoInternet(true)
    }
  }

  const formatData = async ocs => {
    console.log('ocs:', ocs)
    let data = []
    for (const oc of ocs) {
      oc.oc = oc.orderNumber
      oc.dni = oc.clientDni + ' / ' + oc.dispatchDni
      oc.name = oc.clientName
      oc.guide = oc.guideNumber
      // eslint-disable-next-line no-unused-expressions
      oc.origintype
      data.push(oc)
    }
    return data
  }

  const handleScan = async (data) => {
    if (data) {
      try {
        const dni = String(JSON.parse(data).orderNumber).padStart(10, "0")
        console.log('DNI: ', dni)
        setScanning(false)
        if (dni) {
          setTextSearch(dni)
          try {
            setLoading(true)
            const ocs = await ProvidersService.getOcsByDni(dni, userappret.pickupPointId)
            // if (ocs.length === 1) {
            //   setDeliveryData(await formatData(ocs))
            //   setLoading(false)
            //   // history.push(`/entrega/${dni}`, {
            //   //   searching: dni
            //   // })
            // } else
            if (ocs.length >= 1) {
              setDeliveryData(await formatData(ocs))
              setLoading(false)
            } else {
              setLoading(false)
              setModalWarning(true)
            }
          } catch (e) {
            console.log(e)
            setLoading(false)
            setModalNoInternet(true)
          }
        } else {
          console.log('No hay dni')
          setModalNoqr(true)
        }
      } catch (e) {
        console.log('Error: ', e)
        setScanning(false)
        setModalNoqr(true)
      }
    }
  }

  return !scanning ? (
    <Layout>
      <Loading visible={loading} />
      <SimpleModal
        visible={alertSession}
        message='Tiene una sesión pendiente, porfavor termina la sesión para poder crear otra'
        type={1}
      />
      <MessageModal visible={modalWarning} closeModal={() => setModalWarning(false)} message='No se encontraron pedidos' type={1} />
      <MessageModal visible={modalNoqr} closeModal={() => setModalNoqr(false)} message='El QR escaneado no es válido' type={1} />
      <MessageModal visible={modalNoInternet} closeModal={() => setModalNoInternet(false)} message='No tiene conexión a internet' type={2} />
      <MessageModal visible={modalIncomplete} closeModal={() => setModalIncomplete(false)} message='No puedes entregar este pedido porque aún hay productos pendientes' type={21} title='Pedido incompleto' txtBtn1='REGRESAR A LA LISTA' onClickBtn1={() => setModalIncomplete(false)} />
      <div className='delivery-container'>
        <div className='delivery-header'>
          <Link to='/home' style={{ display: 'flex' }}><img src={ArrowSvg} alt='atras' /></Link>
          <h3>Entrega de pedido</h3>
        </div>
        <div className='delivery-search-container'>
          <Search
            text={textSearch}
            setText={handleTextChange}
            placeholder={'Buscar por DNI, nombres'}
            onEnter={handleEnter}
          />
          <div className='delivery-qr-logo' onClick={() => {
            setScanning(true)
          }}>
            <img src={QrSvg} alt='qr' />
          </div>
        </div>
        <div className='delivery-paper-container'>
          {renderValues()}
        </div>
      </div>
    </Layout>
  ) : <QrScan handleScan={handleScan} onClose={() => setScanning(false)} title='Escaneo de QR' subtitle='Escanea el código QR asociado al pedido.' />
}

export default Delivery
